// src/values/Object.ts
import { cloneDeep } from "lodash-es";
function useObjectValueByPath(item, path, value) {
  const keys = path.split(".");
  let current = item;
  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    if (!current[key]) {
      current[key] = {};
    }
    current = current[key];
  }
  if (!useIsNull(value)) {
    current[keys[keys.length - 1]] = value;
  }
  return current[keys[keys.length - 1]];
}
function useIsNull(val) {
  return val === null || val === void 0;
}
function useCloneDeep(value) {
  return cloneDeep(value);
}
function useCoalesce(...values) {
  for (const value of values) {
    if (!useIsNull(value)) {
      return value;
    }
  }
  return void 0;
}
function useCoalesceTruthy(...values) {
  for (const value of values) {
    if (value) {
      return value;
    }
  }
  return useCoalesce(...values);
}
function useMapper(classType, src) {
  const instance = new classType();
  for (const key of Object.keys(instance)) {
    instance[key] = src[key];
  }
  return instance;
}
function useIsNullOrEmptyObject(val) {
  if (!val) {
    return true;
  }
  if (typeof val !== "object") {
    return false;
  }
  if (Array.isArray(val)) {
    return val.length === 0;
  }
  return Object.keys(val).length === 0;
}

export {
  useObjectValueByPath,
  useIsNull,
  useCloneDeep,
  useCoalesce,
  useCoalesceTruthy,
  useMapper,
  useIsNullOrEmptyObject
};
